export enum JamarekTaxType{
    Jamarek=1,
    Tax=2,
}